export function mountHeroCarousel(root, window, document) {
  if (!root) return null;
  const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
  const controls = root.querySelector('[data-hero-controls]');
  if (slides.length < 2 || !controls) return null;
  const previous = controls.querySelector('[data-hero-previous]');
  const next = controls.querySelector('[data-hero-next]');
  const toggle = controls.querySelector('[data-hero-toggle]');
  const count = controls.querySelector('[data-hero-count]');
  const title = root.querySelector('[data-hero-title]');
  const story = root.querySelector('[data-hero-story]');
  const status = root.querySelector('[data-hero-status]');
  if (!previous || !next || !toggle || !count || !title || !story) return null;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let index = 0, paused = reduced.matches, hovered = false, focused = false, timer = null;
  const stop = () => { if (timer !== null) window.clearInterval(timer); timer = null; };
  const paint = (announce = false) => {
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    const slide = slides[index];
    title.textContent = slide.dataset.title || '';
    story.textContent = slide.dataset.story || '';
    count.textContent = `${index + 1} / ${slides.length}`;
    toggle.textContent = paused ? root.dataset.playLabel : root.dataset.pauseLabel;
    toggle.setAttribute('aria-pressed', String(paused));
    if (announce && status) status.textContent = title.textContent;
  };
  const schedule = () => {
    stop();
    if (!paused && !hovered && !focused && !document.hidden  )
      timer = window.setInterval(() => { const candidate = (index + 1) % slides.length; if (slides[candidate].complete && slides[candidate].naturalWidth > 0) { index = candidate; paint(); } }, 4000);
  };
  const move = delta => { index = (index + delta + slides.length) % slides.length; paused = true; paint(true); schedule(); };
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  toggle.addEventListener('click', () => { paused = !paused; paint(); schedule(); });
  controls.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); }
  });
  root.addEventListener('mouseenter', () => { hovered = true; schedule(); });
  root.addEventListener('mouseleave', () => { hovered = false; schedule(); });
  root.addEventListener('focusin', () => { focused = true; schedule(); });
  root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { focused = false; schedule(); } });
  document.addEventListener('visibilitychange', schedule);
  reduced.addEventListener('change', () => { if (reduced.matches) paused = true; paint(); schedule(); });
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', schedule);
  controls.hidden = false;
  paint(); schedule();
  return { next: () => move(1), previous: () => move(-1), pause: () => { paused = true; paint(); schedule(); }, stop };
}
if (typeof document !== 'undefined') mountHeroCarousel(document.querySelector('[data-hero-carousel]'), window, document);
